<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        :vid="id"
        v-slot="{ validated, valid, errors }"
        slim
    >
        <rkm-form-group
            v-if="label"
            :invalid-feedback="errors[0]"
            :label-for="id"
            :description="description"
            :label="label + (validations && validations.required ? ' *' : '')"
            :state="rules ? (disabled ? null : (validated ? valid : null)) : null"
        >
            <b-form-textarea
                :disabled="disabled"
                :formatter="formatter"
                :id="id"
                :max-rows="maxRows"
                :maxlength="maxlength"
                :placeholder="placeholder"
                :readonly="readonly"
                :required="required"
                :rows="rows"
                :size="size"
                :state="rules ? (disabled ? null : (validated ? valid : null)) : null"
                :value="value"
                @blur="$emit('blur', $event)"
                @click="$emit('change', $event)"
                @input="$emit('input', $event)"
                @update="$emit('update', $event)"
            />

            <div
                v-if="rules && rules.max"
                :style="caracteresRestantesStyle"
            >
                Caracteres restantes: {{ caracteresRestantes }}
            </div>
        </rkm-form-group>

        <template v-else>
            <b-form-textarea
                :disabled="disabled"
                :formatter="formatter"
                :max-rows="maxRows"
                :maxlength="maxlength"
                :placeholder="placeholder"
                :readonly="readonly"
                :required="required"
                :rows="rows"
                :size="size"
                :state="rules ? (disabled ? null : (validated ? valid : null)) : null"
                :value="value"
                @blur="$emit('blur', $event)"
                @click="$emit('change', $event)"
                @input="$emit('input', $event)"
                @update="$emit('update', $event)"
            />

            <div
                v-if="rules && rules.max"
                :style="caracteresRestantesStyle"
            >
                Caracteres restantes: {{ caracteresRestantes }}
            </div>
        </template>
    </ValidationProvider>
</template>

<script>
import { BFormTextarea } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate';

export default {
    components: { BFormTextarea, ValidationProvider },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        },
        id() {

            // TODO: Centralizar e a tratar melhor a string, removendo caracteres especiais, acentos, etc.
            const id = (this.label || this.name || 'unknown')
                .toLowerCase()
                .replace(/[()\\/\-<>]/gi, '')
                .replace(/[\s]/gi, '-')

            return this.uniqueId(id)
        },
        rules() {

            return this.disabled ? null : this.validations
        },
        caracteresRestantes() {

            const value = (typeof this.value === 'string') ? this.value.length : 0
            const charactersLeft = this.rules.max - value

            return charactersLeft > 0 ? charactersLeft : 0
        },
        caracteresRestantesStyle() {

            return {
                fontSize: '13px',
                color: 'gray',
            }
        }
    },
    props: {
        disabled: { type: Boolean },
        formatter: { type: Function },
        description: { type: String },
        label: { type: String },
        large: { type: Boolean, default: false },
        maxRows: { type: [Number, String] },
        maxlength: { type: [Number, String], required: false },
        validationMode: { type: String, default: 'aggressive' },
        name: { type: String },
        placeholder: { type: String },
        readonly: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
        rows: { type: [Number, String], default: 2 },
        small: { type: Boolean, default: false },
        state: { type: Boolean, default: null },
        type: { type: String, default: 'text' },
        validations: { type: Object, default: null },
        value: { type: [Number, String], default: '' },
    }
}
</script>